import ReactHtmlParser from 'html-react-parser';
import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { MDSTypography } from '@marqvision/mds-v2';
import { VideoImageContent } from '@marqvision/shared';
import { useViewModel } from './@hooks/useViewModel';

const useStyles = makeStyles(() => ({
  content: {
    padding: '16px 20px',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    gap: '16px',
    '& u': {
      textDecoration: 'underline',
    },
    '& .ql-editor': {
      padding: 0,
    },
  },
}));

type Props = {
  selectedId: number;
};

export const Detail = (props: Props) => {
  const { selectedId } = props;
  const classes = useStyles();

  const { isLoading, data } = useViewModel(selectedId);

  const content = data?.content ? ReactHtmlParser(data.content) : '';

  return (
    <div>
      {data?.mainContent && <VideoImageContent url={data.mainContent} />}
      <div className={classes.content}>
        <MDSTypography color="color/content/neutral/secondary/normal">
          {isLoading ? <Skeleton /> : data?.date}
        </MDSTypography>
        <MDSTypography variant="title" size="l" weight="semibold">
          {isLoading ? <Skeleton /> : data?.title}
        </MDSTypography>
        <MDSTypography whiteSpace="pre-wrap" className="ql-editor">
          {isLoading ? <Skeleton /> : content}
        </MDSTypography>
      </div>
    </div>
  );
};
